module.exports = __webpack_public_path__ + "img/Balance-1-mobile.be43cf0a.jpg";